import { Dialog } from 'primereact/dialog';
import SingleAddPeopleForm from '../components/SingleAddPeopleForm';
import StyledTabView from '@/components/tabs/StyledTabView';
import { TextHeadlineLarge, TextTitleMedium2 } from '@/components/text/Texts';
import { Column } from '@/components/container/Container';
import { MdClose } from 'react-icons/md';
import { GetGroupResponse } from './GroupInfoScreen';
import BulkAddPeopleForm from '../components/BulkAddPeopleForm';
import { useModal } from '@ebay/nice-modal-react';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/roles';

interface Props { group: GetGroupResponse }

const AddGroupNewPeopleScreen = ({ group }: Props) => {
	const modal = useModal();

	// TODO PHASE2 NOTIF MESSAGES
	// 		bannerMessage = 'Employee added to the group successfully.';
	// 		bannerMessage = 'Employees added to the group successfully.';

	const handleClose = () => {
		modal.resolve();
		modal.remove();
	};

	return (
		<Dialog
			unstyled
			onHide={handleClose}
			visible={modal.visible}
			maskStyle={{ backgroundColor: '#00000047' }}
			closeIcon={(<MdClose size={24} className="text-onSurfaceVariant rounded-full duration-200 hover:bg-gray-200" />)}
			pt={{
				root: { className: 'py-6 px-8 rounded-[28px] w-[1136px] tablet:!w-[calc(100vw-6rem)] tablet:!max-w-[calc(100vw-6rem)] bg-white relative' },
				content: { className: 'p-0' },
				header: { className: 'absolute right-6 top-6' }
			}}
		>
			<Column className="gap-2 mb-4">
				<TextHeadlineLarge text="Add People" className="text-neutral17" />
				<TextTitleMedium2
					className="text-onSurfaceVariant"
					children={(<>Group: <span className="font-semibold">{group.Name}</span></>)}
				/>
			</Column>

			<StyledTabView tabs={[
				{ header: 'Single Add', content: (<SingleAddPeopleForm handleSelfClose={handleClose} groupId={group.Id} />) },
				{ header: 'Upload CSV', content: (<BulkAddPeopleForm handleSelfClose={handleClose} groupId={group.Id} />) },
			]} />
		</Dialog>
	);
};

export default AddGroupNewPeopleScreen;
